import PropTypes from 'prop-types';
import React from 'react';
import { trackCustomEvent } from '../../utils/statistics/clientStatistics';
import { listTrackingEvent } from '../../utils/statistics/customEvents';
import PlayImage from '../PlayImage/PlayImage';
import { ItemCaption, ItemLink, PromotionItemWrapper } from './PromotionItem.styles';

export const trackListClick = (e, name, listItemIndex, listExpandedState) => {
    trackCustomEvent(
        listTrackingEvent(
            {
                listID: 'kategorilista',
                listType: 'kategorier',
                listItemIndex,
                listExpandedState,
                contentId: name,
            },
            e.currentTarget
        )
    );
};

const PromotionItem = ({ item, className, index, expanded }) => (
    <PromotionItemWrapper data-rt="promotion-item" data-rt-genre={`genre-${item.name}`} className={className}>
        <ItemLink to={item.urlPart} onAfterClick={(e) => trackListClick(e, item.name, index, expanded)}>
            <PlayImage src={item.posterImageUrl} alt={item.posterAltText} />
            <ItemCaption>
                <span>{item.name}</span>
            </ItemCaption>
        </ItemLink>
    </PromotionItemWrapper>
);

PromotionItem.propTypes = {
    item: PropTypes.object,
};

export default PromotionItem;
